import { observer } from 'mobx-react-lite'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../app/stores/store'
import { currencyValue, formatCurrency } from '../muiStyle/muiStyle'

interface Props {
  handleClose: any
  handleSubmit: any
  loadingBtn: boolean
  title: string
  price: number
  buyNow?: boolean
}

function ConfirmBidPopup({
  handleClose,
  handleSubmit,
  loadingBtn,
  title,
  price,
  buyNow = false,
}: Props) {
  const { bidsStore } = useStore()
  const { t } = useTranslation()

  const currencyName = currencyValue.find(
    (item) => item.value === bidsStore.auctionDetails?.post?.currency,
  )?.name

  return (
    <div className="newFont prevent-select">
      <Modal.Header className="bg-white">
        <p className="post-card-title">
          {buyNow ? t('auction_buyNow_confirm') : t('auction_bid_confirm')}
        </p>
        <Button variant="inherit" className="close me-2 d-flex justify-content-center align-items-center p-0" onClick={handleClose}>
          <i className="fa-regular fa-x icon-size" />
        </Button>
      </Modal.Header>
      <Modal.Body className="post-card-padding card-font-size">
        <p>{t('confirm_header')},</p>
        {buyNow ? (
          <>
            <p>
              {t('confirm_bid_txt1')} <strong>{title}</strong>.{' '}
              {t('confirm_bid_txt2')}
            </p>
            <p>
              {t('confirm_bid_txt3')}{' '}
              <strong>
                {formatCurrency(price)}
                {currencyName}
              </strong>
              . {t('confirm_bid_txt4')}
            </p>
          </>
        ) : (
          <>
            <p>
              {t('confirm_bid_txt5')} <strong>{`${title} `}</strong>
              {t('confirm_bid_txt6')}
            </p>
            <p>
              {t('confirm_bid_txt7')}{' '}
              <strong>
                {formatCurrency(price * 100)} {currencyName}
              </strong>
              , {t('confirm_bid_txt8')}
            </p>
          </>
        )}

        <div className="auction-create-buttons">
          <button
            onClick={handleClose}
            className="text-white payment-button-cancel"
          >
            {t('cancel')}
          </button>
          <button
            onClick={handleSubmit}
            className="text-white payment-button-tryagain"
            disabled={loadingBtn}
          >
            {loadingBtn ? (
              <Spinner animation="border" variant="light" />
            ) : buyNow ? (
              t('buy_now')
            ) : (
              t('confirm_bid')
            )}
          </button>
        </div>
      </Modal.Body>
    </div>
  )
}
export default observer(ConfirmBidPopup)
